import { memo } from 'react'
import { Card, CardActions, CardContent, CardHeader, Typography } from '@maas-components/core'
import { TCardStepProps } from './types'

const CardStep = ({
  title,
  description,
  children,
  headerAction,
  footerActions,
}: TCardStepProps) => {
  return (
    <Card raised elevation={1} className="p-4">
      <CardHeader
        disableTypography
        className="p-0"
        title={
          <Typography variant="h5" component="h2" className="mb-4">
            {title}
          </Typography>
        }
        subheader={
          description && (
            <Typography variant="body1" color="secondary" className="mb-4">
              {description}
            </Typography>
          )
        }
        action={headerAction}
      />

      <CardContent className="p-0">{children}</CardContent>
      {footerActions && <CardActions>{footerActions}</CardActions>}
    </Card>
  )
}

export default memo(CardStep)
